import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/solid";


function FaqLiquidatif() {
  return (
    <section class=" mt-4 flex flex-row flex-wrap justify-center items-center bg-slate-100">
      <div className="py-14 sm:py-20 ">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto text-center">
            <h2 className="text-2xl font-bold tracking-tight leading-10 text-gray-900 sm:text-2xl">
              <span className="font-bold text-indigo-800">Etat liquidatif chez le notaire</span>
              : 5 informations importantes</h2>

          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0 sm:max-w-[60%] mx-auto">
            <dl className="space-y-10">

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Qu'est-ce qu'un état liquidatif ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                L'état liquidatif est un document officiel qui détaille la répartition des biens entre plusieurs personnes au moment d'une séparation, d'un divorce, ou d'une succession. Il liste les actifs, leur valeur et indique comment ils sont partagés entre les parties.
                </dd>
              </div>

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Quand est-il nécessaire d'établir un état liquidatif ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                L'état liquidatif est obligatoire lors d'un divorce s'il existe des biens communs, ou en cas de sortie d'indivision, notamment lorsqu'un bien immobilier est concerné. Il est également indispensable pour partager un patrimoine après un décès (succession).
                </dd>
              </div>

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Le notaire est-il obligatoire pour un état liquidatif ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                Oui, l'intervention d'un notaire est obligatoire dès qu'un bien immobilier est concerné par le partage. Le notaire établit l'acte authentique, sécurise la répartition des biens et veille à la bonne application des règles légales.
                </dd>
              </div>


              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Que contient concrètement un état liquidatif ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                L'état liquidatif liste :
                <br />
                <ul>
                  <li>• <span className="font-bold text-indigo-800">Les biens concernés</span> (immobiliers, mobiliers, comptes bancaires, etc.)</li>
                  <li>• <span className="font-bold text-indigo-800">La valeur attribuée à chaque bien</span></li>
                  <li>• <span className="font-bold text-indigo-800">La répartition entre les parties</span> (qui reçoit quoi)</li>
                  <li>• <span className="font-bold text-indigo-800">Les éventuelles soultes</span> (compensations financières si l'un reçoit plus que sa part)</li>
                </ul>
                </dd>
              </div>

              <div className="bg-white my-4 rounded-lg p-4">
                <dt className="text-lg font-semibold leading-7 ">
                Quel est le coût d'un état liquidatif chez le notaire ?
                </dt>
                <dd className="mt-2 text-md leading-7 text-gray-600">
                Le coût dépend de la valeur des biens à partager. À titre indicatif, les frais de notaire pour un état liquidatif sont généralement compris entre 1 % et 2 % de la valeur du patrimoine partagé, auxquels s'ajoutent les frais fixes et les droits d'enregistrement.
                </dd>
              </div>
            </dl>
          </div>


        </div>
        <div className="mx-auto text-center container">
          <p className="text-lg"> Débutez aujourd'hui votre dossier chez le notaire</p>
          <Link to="/onboard/liquidatif"
            type="button"
            className="btn-indigo p-6  no-underline inline-flex items-center w-auto"
          >
            Débuter mon dossier gratuitement
            <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
          </Link>
        </div>

      </div>

    </section>
  );
}

export default FaqLiquidatif;